import React, { Component } from 'react'
import { InputGroup, InputGroupAddon } from 'reactstrap'

const UPLOAD_MAX_SIZE = 1073741824

export class FileInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filename: '',
            sizeLimitMessage: ''
        }
    }

    fileSelected(event) {
        let file = event.target
        console.log('file selected ', file, file.files[0])
        this.setState({ sizeLimitMessage: '' }, () => {
            if (!file || !file.files[0]) return

            if (file.files[0].size > UPLOAD_MAX_SIZE) {
                this.setState({ sizeLimitMessage: 'Maximum upload size is 1GB.' })
                return
            }
            this.setState({
                filename: file.value
            })
            this.props.fileSelected(file.files[0])
        })
    }

    render() {
        return (
            <div className="file-upload">
                <input type="file" className="file" onChange={e => this.fileSelected(e)} />
                <div className="fake-upload" style={{ width: '100%' }}>
                    <InputGroup>
                        <input type="text" className="form-control" value={this.state.filename} />
                        <InputGroupAddon className="input-group-addon">+</InputGroupAddon>
                    </InputGroup>

                    {this.state.sizeLimitMessage != '' && <b style={{ color: 'red' }}>{this.state.sizeLimitMessage}</b>}
                </div>
            </div>
        )
    }
}
